import { createSelector } from 'reselect'
import { entitySelector, resultsSelector } from 'containers/Entity/selectors'
import cloneDeep from 'lodash/cloneDeep'
import {
  projectRoleSelector
} from 'containers/Role/Project/selectors'
import { projectIdSelector } from 'containers/Project/View/selectors'

import {
  globalRoleSelector
} from 'containers/Role/Global/selectors'

const weeklyUpdatesEntitySelector = createSelector(
  entitySelector,
  (entities) => entities.project_weekly_update_views
    ? entities.project_weekly_update_views
    : {}
)

const projectWeeklyUpdatesSelector = state => state.project.projectWeeklyUpdates

const weeklyUpdatesSelector = createSelector(
  weeklyUpdatesEntitySelector,
  (weeklyUpdatesEntity) => Object.values(weeklyUpdatesEntity).sort((a, b) => {
    if(a.year != b.year){
      return -(a.year - b.year)
    } else if (a.workWeek != b.workWeek){
      return -(a.workWeek - b.workWeek)
    } else {
      return -((new Date(a.createdAt)) - (new Date(b.createdAt)))
    }
  })
)

const newWeeklyUpdateSelector = createSelector(
  projectWeeklyUpdatesSelector,
  (projectWeeklyUpdates) => projectWeeklyUpdates.newWeeklyUpdate
)

const weeklyUpdatesLoadingSelector = createSelector(
  projectWeeklyUpdatesSelector,
  (projectWeeklyUpdates) => projectWeeklyUpdates.loading
)

const weeklyUpdatesRemainingLoadingSelector = createSelector(
  projectWeeklyUpdatesSelector,
  (projectWeeklyUpdates) => projectWeeklyUpdates.remainingLoading
)

const weeklyUpdatesAlLFetchedSelector = createSelector(
  projectWeeklyUpdatesSelector,
  (projectWeeklyUpdates) => projectWeeklyUpdates.allFetched
)

const weekSelector = createSelector(
  newWeeklyUpdateSelector,
  (newWeeklyUpdate) => newWeeklyUpdate.week
)

const yearSelector = createSelector(
  newWeeklyUpdateSelector,
  (newWeeklyUpdate) => newWeeklyUpdate.year
)

const roleSelector = createSelector(
  newWeeklyUpdateSelector,
  (newWeeklyUpdate) => newWeeklyUpdate.role
)

const textSelector = createSelector(
  newWeeklyUpdateSelector,
  (newWeeklyUpdate) => newWeeklyUpdate.text
)

const totalCountSelector = createSelector(
  projectWeeklyUpdatesSelector,
  (projectWeeklyUpdate) => projectWeeklyUpdate.totalCount
)

const roleOptionsSelector = createSelector(
  projectRoleSelector,
  globalRoleSelector,
  (projectRoles, globalRoles) => {
    var roles = []
    projectRoles.forEach((role) => {
      roles.push({
        label: role,
        value: role
      })
    })
    if(globalRoles.includes('Admin Access')){
      roles.push({
        label: 'Administrator',
        value: 'Administrator'
      })
    }
    return roles
  }
)

const weeklyUpdateParamsSelector = createSelector(
  weekSelector,
  yearSelector,
  roleSelector,
  textSelector,
  projectIdSelector,
  (week, year, role, text, projectId) => ({
    workWeek: week,
    year,
    role,
    text,
    projectId
  })
)

export {
  weeklyUpdatesSelector,
  weeklyUpdatesLoadingSelector,
  weeklyUpdatesRemainingLoadingSelector,
  weeklyUpdatesAlLFetchedSelector,
  newWeeklyUpdateSelector,
  roleOptionsSelector,
  weekSelector,
  yearSelector,
  roleSelector,
  textSelector,
  weeklyUpdateParamsSelector,
  totalCountSelector
}
